import { module } from 'modujs';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);
        this.text = this.el.querySelectorAll('[data-effect="moving-text"]');
        this.menu = this.el.querySelector('[data-effect="moving-menu"]');
        this.time = this.el.querySelector('[data-effect="moving-time"]');
        this.opening = this.el.querySelector('[data-effect="opening-hours"]');


        this.opening.addEventListener('click', () => {
            this.menu.classList.toggle('show-hours');
        });

        this.text.forEach(element => {
            gsap.timeline({ repeat: 0 })
                .fromTo(element,
                    { y: -2800, opacity: 0 },
                    { y: 0, opacity: 1, duration: 2, ease: "expo.out" }
                )
        });


        gsap.timeline({ repeat: 0 })
            .fromTo(this.menu,
                { y: 2800, opacity: 0 },
                { y: 0, opacity: 1, duration: 2, ease: "expo.out" }
            )

        gsap.timeline({ repeat: 0 })
            .fromTo(this.time,
                { opacity: 0 },
                { opacity: 1, duration: 2, ease: "expo.out", delay: 2 }
            )

    }
}
